import { Component } from '@angular/core';

@Component({
  selector: 'mprd-norton-anti-theft',
  templateUrl: './norton-anti-theft.component.html',
  styleUrls: ['./norton-anti-theft.component.css'],
})
export class NortonAntiTheftComponent {
  constructor() {}
}
